import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';

const CardBlock = ({ className = '', children, ...rest }) => (
  <div className={cx('card-block', className)} {...rest}>
    {children}
  </div>
);

CardBlock.propTypes = {
  className: PropTypes.string,
  chidlren: PropTypes.node,
};

export default CardBlock;
